import { localeISO } from '../../utils/helpers/date'

const state = {
  loading: false,
  filters: {
    initialDate: localeISO(false),
    finalDate: localeISO(false)
  },
  cards: {
    availableOffers: 0,
    totalOffersWeight: 0,
    availableOffersVolume: 0,
    averageTicket: 0,
    offerWaitingTwoDays: 0,
    newDrivers: 0,
    totalDrivers: 0,
    driverAverageAge: 0,
    countVehicles: 0,
    vehicleAverageAge: 0,
    driversInPanic: 0
  }
}

const getters = {
  loading: (state) => state.loading,
  initialDate: (state) => state.filters.initialDate,
  finalDate: (state) => state.filters.finalDate,
  availableOffers: (state) => state.cards.availableOffers,
  totalOffersWeight: (state) => state.cards.totalOffersWeight,
  availableOffersVolume: (state) => state.cards.availableOffersVolume,
  averageTicket: (state) => state.cards.averageTicket,
  offerWaitingTwoDays: (state) => state.cards.offerWaitingTwoDays,
  newDrivers: (state) => state.cards.newDrivers,
  totalDrivers: (state) => state.cards.totalDrivers,
  driverAverageAge: (state) => state.cards.driverAverageAge,
  countVehicles: (state) => state.cards.countVehicles,
  vehicleAverageAge: (state) => state.cards.vehicleAverageAge,
  driversInPanic: (state) => state.cards.driversInPanic
}

const mutations = {
  SET_LOADING(state, payload) {
    state.loading = payload
  },
  SET_INITIAL_DATE(state, payload) {
    state.filters.initialDate = payload
  },
  SET_FINAL_DATE(state, payload) {
    state.filters.finalDate = payload
  },
  SET_AVAILABLE_OFFERS(state, payload) {
    state.cards.availableOffers = payload
  },
  SET_TOTAL_OFFERS_WEIGHT(state, payload) {
    state.cards.totalOffersWeight = payload
  },
  SET_AVAILABLE_OFFERS_VOLUME(state, payload) {
    state.cards.availableOffersVolume = payload
  },
  SET_AVERAGE_TICKET(state, payload) {
    state.cards.averageTicket = payload
  },
  SET_OFFER_WAITING_TWO_DAYS(state, payload) {
    state.cards.offerWaitingTwoDays = payload
  },
  SET_NEW_DRIVERS(state, payload) {
    state.cards.newDrivers = payload
  },
  SET_TOTAL_DRIVERS(state, payload) {
    state.cards.totalDrivers = payload
  },
  SET_DRIVER_AVERAGE_AGE(state, payload) {
    state.cards.driverAverageAge = payload
  },
  SET_COUNT_VEHICLES(state, payload) {
    state.cards.countVehicles = payload
  },
  SET_VEHICLE_AVERAGE_AGE(state, payload) {
    state.cards.vehicleAverageAge = payload
  },
  SET_DRIVERS_IN_PANIC(state, payload) {
    state.cards.driversInPanic = payload
  }
}

const actions = {
  async getAvailableOffers({ state, commit, dispatch }) {
    commit('SET_LOADING', true)

    const response = await dispatch(
      `api`,
      {
        entity: `dashboardCards`,
        action: `availableOffers`,
        query: `?initial_date=${state.filters.initialDate}&final_date=${state.filters.finalDate}`
      },
      { root: true }
    )

    if (response && response.status) {
      let availableOffers = await response?.data[0]?.count
      commit('SET_AVAILABLE_OFFERS', availableOffers)
    }

    commit('SET_LOADING', false)
  },
  async getTotalOffersWeight({ state, commit, dispatch }) {
    commit('SET_LOADING', true)

    const response = await dispatch(
      `api`,
      {
        entity: `dashboardCards`,
        action: `totalOffersWeight`,
        query: `?initial_date=${state.filters.initialDate}&final_date=${state.filters.finalDate}`
      },
      { root: true }
    )

    if (response && response.status === 200) {
      const totalOffersWeight = await response?.data[0]?.count
      commit('SET_TOTAL_OFFERS_WEIGHT', totalOffersWeight?.toFixed(2))
    }

    commit('SET_LOADING', false)
  },
  async getAvailableOffersVolume({ state, commit, dispatch }) {
    commit('SET_LOADING', true)

    const response = await dispatch(
      `api`,
      {
        entity: `dashboardCards`,
        action: `availableOffersVolume`,
        query: `?initial_date=${state.filters.initialDate}&final_date=${state.filters.finalDate}`
      },
      { root: true }
    )

    if (response && response.status === 200) {
      const availableOffersVolume = await response?.data[0]?.count
      commit('SET_AVAILABLE_OFFERS_VOLUME', availableOffersVolume?.toFixed(2))
    }
    commit('SET_LOADING', false)
  },
  async getAverageTicket({ state, commit, dispatch }) {
    commit('SET_LOADING', true)

    const response = await dispatch(
      `api`,
      {
        entity: `dashboardCards`,
        action: `averageTicket`,
        query: `?initial_date=${state.filters.initialDate}&final_date=${state.filters.finalDate}`
      },
      { root: true }
    )

    if (response && response.status === 200) {
      const total = await response?.data[0]?.count
      const totalCurrency = total?.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      })
      commit('SET_AVERAGE_TICKET', totalCurrency)
    }
    commit('SET_LOADING', false)
  },
  async getOfferWaitingTwoDays({ state, commit, dispatch }) {
    commit('SET_LOADING', true)

    const response = await dispatch(
      `api`,
      {
        entity: `dashboardCards`,
        action: `offerWaitingTwoDays`,
        query: `?initial_date=${state.filters.initialDate}&final_date=${state.filters.finalDate}`
      },
      { root: true }
    )

    if (response && response.status === 200) {
      const offerWaitingTwoDays = await response?.data[0]?.count
      commit('SET_OFFER_WAITING_TWO_DAYS', offerWaitingTwoDays)
    }

    commit('SET_LOADING', false)
  },
  async getNewDrivers({ state, commit, dispatch }) {
    commit('SET_LOADING', true)

    const response = await dispatch(
      `api`,
      {
        entity: `dashboardCards`,
        action: `newDrivers`,
        query: `?initial_date=${state.filters.initialDate}&final_date=${state.filters.finalDate}`
      },
      { root: true }
    )

    if (response && response.status === 200) {
      let totalNewDrivers = 0
      if (response && response.data) {
        for (let i = 0; i < response.data.length; i++) {
          totalNewDrivers += response.data[i].count
        }
      }
      commit('SET_NEW_DRIVERS', totalNewDrivers)
    }

    commit('SET_LOADING', false)
  },
  async getTotalDrivers({ state, commit, dispatch }) {
    commit('SET_LOADING', true)

    const response = await dispatch(
      `api`,
      {
        entity: `dashboardCards`,
        action: `totalDrivers`,
        query: `?initial_date=${state.filters.initialDate}&final_date=${state.filters.finalDate}`
      },
      { root: true }
    )

    if (response && response.status === 200) {
      const totalDrivers = await response?.data[0]?.count
      commit('SET_TOTAL_DRIVERS', totalDrivers)
    }

    commit('SET_LOADING', false)
  },
  async getDriverAverageAge({ state, commit, dispatch }) {
    commit('SET_LOADING', true)

    const response = await dispatch(
      `api`,
      {
        entity: `dashboardCards`,
        action: `driverAverageAge`,
        query: `?initial_date=${state.filters.initialDate}&final_date=${state.filters.finalDate}`
      },
      { root: true }
    )

    if (response && response.status === 200) {
      const driverAverageAge = await response?.data[0]?.count
      commit('SET_DRIVER_AVERAGE_AGE', driverAverageAge)
    }

    commit('SET_LOADING', false)
  },
  async getCountVehicles({ state, commit, dispatch }) {
    commit('SET_LOADING', true)

    const response = await dispatch(
      `api`,
      {
        entity: `dashboardCards`,
        action: `countVehicles`,
        query: `?initial_date=${state.filters.initialDate}&final_date=${state.filters.finalDate}`
      },
      { root: true }
    )

    if (response && response.status === 200) {
      const countVehicles = await response?.data[0]?.count
      commit('SET_COUNT_VEHICLES', countVehicles)
    }

    commit('SET_LOADING', false)
  },
  async getVehicleAverageAge({ state, commit, dispatch }) {
    commit('SET_LOADING', true)

    const response = await dispatch(
      `api`,
      {
        entity: `dashboardCards`,
        action: `vehicleAverageAge`,
        query: `?initial_date=${state.filters.initialDate}&final_date=${state.filters.finalDate}`
      },
      { root: true }
    )

    if (response && response.status === 200) {
      const vehicleAverageAge = await response?.data[0]?.count
      commit('SET_VEHICLE_AVERAGE_AGE', vehicleAverageAge)
    }

    commit('SET_LOADING', false)
  },
  async getDriversInPanic({ commit, dispatch }) {
    commit('SET_LOADING', true)

    const response = await dispatch(
      `api`,
      {
        entity: `dashboardCards`,
        action: `driversInPanic`
      },
      { root: true }
    )

    if (response && response.status === 200) {
      const driversInPanic = await response?.data
      console.log(driversInPanic)
      commit('SET_DRIVERS_IN_PANIC', driversInPanic)
    }

    commit('SET_LOADING', false)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
